import React from 'react';
import MySubAffiliates from './MySubAffiliates';

export default function SubAffiliatesIndex(){
   return <MySubAffiliates />
}
